var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var active = {
    borderWidth: 2,
    borderColor: '#003FB8',
    margin: -1,
};
export var focusHover = {
    borderWidth: 2,
    borderColor: '#2B66D6',
    margin: -1,
};
export var textarea = __assign(__assign({}, reset), { backgroundColor: '#ffffff', borderWidth: 1, borderStyle: 'solid', borderColor: '#7E8A94', borderRadius: 8, boxSizing: 'border-box', color: '#000000', display: 'block', fontSize: 16, outline: 'none', overflow: 'auto', padding: "".concat(8, "px 12px"), position: 'relative', resize: 'vertical', width: '100%', '::placeholder': {
        color: '#42505C',
    }, ':active': active, ':focus': focusHover, ':hover': focusHover });
export var disabled = {
    backgroundColor: '#DFE4E8',
    borderColor: '#A8B2BA',
    borderWidth: 2,
    color: '#8E9AA3',
    cursor: 'not-allowed',
    '::placeholder': {
        color: '#8E9AA3',
    },
    ':hover': {
        borderColor: '#A8B2BA',
        margin: 0,
    },
};
export var error = {
    borderWidth: 2,
    borderColor: '#CC0821',
    ':hover, :focus': {
        borderColor: '#CC0821',
        margin: 0,
    },
};
